import classnames from 'classnames';

import type { Country } from 'hocs/countries/api/types';
import type { PhoneNumbersSearch } from 'hocs/telephony/api/types';

import PrettyNumber from './PrettyNumber';
import styles from './foundItem.module.scss';

type PropsT = {
  number: PhoneNumbersSearch;
  country: Country;
  onBuyClickHandle: () => void;
};

const FoundNumber = ({ number, country, onBuyClickHandle }: PropsT) => {
  const { region, phone_number } = number;
  const { country_code } = country;

  return (
    <div className={classnames(styles.wrapper, 'flags')}>
      <span className={classnames('flag', country_code.toLowerCase())} />
      <PrettyNumber number={phone_number} />
      {region && <span className={styles.name}>{region.toLowerCase()}</span>}
      <button className={styles.button} onClick={onBuyClickHandle}>
        Buy
      </button>
    </div>
  );
};

export default FoundNumber;
